import { InjectionToken } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { AnalyticsService } from 'app/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import * as fromOrganization from 'app/store/organization.actions';
import { organizationInfoSelector } from 'app/store/organization.selectors';
import { registerLocaleData } from '@angular/common';

export const APP_ORGANIZATION_CODE = new InjectionToken('User Configuration', {
  factory: () => {
    return 'geco'
  }
});

export interface InitData {
  organizationCode: string;
  baseHref: string;
}

export const getInitData = (window: Window): InitData => {
  let organizationCode = 'geco';

  // если это сервер виджета, то ищем код организации в пути
  if (
    window.location.pathname && window.location.pathname !== '/'
  ) {
    let path = window.location.pathname.split('/');
    organizationCode = path.length > 1 ? path[1] : '';
    if (!organizationCode.length) {
      organizationCode = 'geco'
    }
  }
  const baseHref = '/' + organizationCode;
  return {
    organizationCode,
    baseHref
  };
}

export const appInitializer = (
  store: Store<AppState>,
  organizationCode: string,
  analyticsService: AnalyticsService,
  translateService: TranslateService
) => {
  return (): Observable<string> => {
    return store.select('organizationInfo').pipe(
      take(1),
      switchMap(appState => {
        if (!appState.organizationInfo) {
          if (!appState.isLoading) {
            store.dispatch(fromOrganization.fetchOrganizationAction(organizationCode));
          }
        }
        return store.select(organizationInfoSelector).pipe(
          filter((organization) => organization !== null),
          take(1),
          switchMap((organization) => {
            let lang = organization?.language ?? 'ru';
            if (organization) {
              analyticsService.init(organization);
            }

            // язык подгрузим полюбому
            translateService.use(lang);
            let promise = import(
              // locales
              // https://github.com/angular/angular/issues/20487
              /* webpackInclude: /(en|ru)\.mjs$/ */
              `node_modules/@angular/common/locales/${lang}.mjs`
              );
            promise.then((module) => {
              registerLocaleData(module.default);
            });
            return from(promise).pipe(
              map(
                () => {
                  return lang;
                }
              )
            )
          })
        );
      })
    );
  };
}

export const localeInitializer = (store: Store<AppState>) => {
  let lang = 'en';
  store.select(organizationInfoSelector).pipe(take(1)).subscribe(organization => lang = organization?.language ?? 'ru');
  return lang
}
